import { BaseDto } from '@/shared/dtos/base-dto';

export class pedido extends BaseDto {
    public fecha_pedido!:Date;
    public referencia !: string;
    public precio_sin_iva !: number;
    public precio_con_iva !: number;
    public porcentaje_iva !: number;
    public valor_amazon !: number;
    public porcentaje_valor_iva !: number;
    public porcentaje_valor_sin_iva !: number;
    public estado !: string;
    public comentarios !: string;
    public nombre_archivo_importar!: string;
 } 
